// extracted by mini-css-extract-plugin
module.exports = {"spin":"animations_spin__1VN_0","button":"StoryStartButtons_button__28Yqf","featured":"StoryStartButtons_featured__AcLv4","spinner":"StoryStartButtons_spinner__17kpA"};